import React from "react";
import { timeline } from "../mock";

export default function Journey() {
  return (
    <section id="journey" className="py-28 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
          <div>
            <div className="text-xs tracking-[0.32em] text-emerald-400 uppercase mb-4">05 — Journey</div>
            <h2 className="gt-serif text-4xl md:text-5xl max-w-2xl">A decade of turning language into leverage.</h2>
          </div>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-emerald-400/60 via-white/10 to-transparent" />
          <div className="space-y-14">
            {timeline.map((t, i) => (
              <div
                key={t.year}
                className={`relative md:grid md:grid-cols-2 md:gap-14 items-start ${
                  i % 2 === 0 ? "" : "md:[&>*:first-child]:col-start-2"
                }`}
              >
                <div className="absolute left-4 md:left-1/2 -translate-x-1/2 mt-2 w-3 h-3 rounded-full bg-emerald-400 ring-4 ring-emerald-400/20" />
                <div className={`pl-12 md:pl-0 ${i % 2 === 0 ? "md:pr-14 md:text-right" : "md:pl-14"}`}>
                  <div className="text-xs tracking-[0.3em] text-emerald-400 uppercase">{t.year}</div>
                  <h3 className="gt-serif text-2xl md:text-3xl text-white mt-2">{t.title}</h3>
                  <p className="text-neutral-400 mt-3 leading-relaxed">{t.copy}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
